import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Zap, CreditCard } from 'lucide-react';
export function FinalCta() {
  return <section className="py-20 px-4 bg-gradient-to-t from-brand/5 to-background border-t border-border" data-id="element-97">
      <div className="max-w-4xl mx-auto text-center" data-id="element-98">
        <h2 className="text-3xl font-heading font-bold text-white mb-6" data-id="element-99">
          ⏰ EL PRECIO CIERRA EN:
        </h2>
        <CountdownTimer className="mb-12" data-id="element-100" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-101">
          {/* Standard */}
          <div className="bg-surface border border-border rounded-2xl p-6 flex flex-col items-center" data-id="element-102">
            <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-103">
              📘 MEGAPACK SCOOTER ELÉCTRICO
            </h3>
            <p className="text-sm text-muted mb-4" data-id="element-104">
              3 eBooks + 3 Bonos · Para cualquier scooter
            </p>
            <div className="flex items-center gap-2 text-danger line-through font-bold mb-1" data-id="element-105">
              $45.000
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-6" data-id="element-106">
              $19.990 ARS
            </div>
            <CtaButton variant="brand" className="w-full py-3 text-base" data-id="element-107">
              → QUIERO MI MEGAPACK
            </CtaButton>
          </div>

          {/* Pro */}
          <div className="bg-surface border-2 border-accent rounded-2xl p-6 flex flex-col items-center relative" data-id="element-108">
            <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-109">
              🏆 MEGAPACK + KIT SISTEMA DE GESTIÓN PRO ⭐
            </h3>
            <p className="text-sm text-accent mb-4" data-id="element-110">
              3 eBooks + 3 Bonos + Kit Pro completo
            </p>
            <div className="flex items-center gap-2 text-danger line-through font-bold mb-1" data-id="element-111">
              $65.000
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-6" data-id="element-112">
              $27.990 ARS
            </div>
            <CtaButton variant="accent" className="w-full py-3 text-base" data-id="element-113">
              → QUIERO EL MEGAPACK + KIT PRO
            </CtaButton>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-muted font-medium" data-id="element-114">
          <span className="flex items-center gap-2" data-id="element-115">
            <ShieldCheck className="text-brand" size={18} data-id="element-116" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-117">
            <Zap className="text-accent" size={18} data-id="element-118" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-119">
            <CreditCard className="text-blue-400" size={18} data-id="element-120" /> Mercado Pago |
            Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}